import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import countriesList from "../Seeds/country";
import { useDispatch } from "react-redux";
import { addFilter } from "../features/Filter/FilterSlice";

export default function CountrySelect() {
  const dispatch = useDispatch();
  return (
    <Autocomplete
      id="country-select-demo"
      options={countriesList}
      onChange={(event, newValue) => {
        dispatch(
          addFilter({ key: "Pays", value: newValue.map((item) => item.cca2) })
        );
      }}
      multiple
      autoHighlight
      getOptionLabel={(option) => option.translations.fra.common}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
          key={option.cca2}
        >
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.cca2.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.cca2.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.translations.fra.common} ({option.cca2})
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Choisissez un pays"
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}
